import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from 'src/app/base/base.component';
import { FtpServerType, FtpServerTypeUtil, FtpService } from 'src/app/domainObjects/dataConnector';
import { ConfigService } from 'src/app/services/config/config.service';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-ftp-service-form',
    templateUrl: './ftp-service-form.component.html',
    styleUrls: ['./ftp-service-form.component.css'],
    standalone: false
})
export class FtpServiceFormComponent extends BaseComponent{
  @Input() value!: FtpService;
  @Output() valueChange = new EventEmitter<FtpService>();

  form!: FormGroup;
  
  FtpServerType=FtpServerType;
  FtpServerTypeUtil = FtpServerTypeUtil;
  FtpServerTypes = [
    FtpServerType.FTP,
    FtpServerType.SFTP,
  ];

  constructor(private fb: FormBuilder,private configService: ConfigService,matDialog: MatDialog,errorLogger: ErrorReportingService) {super(errorLogger, matDialog);}

  ngOnInit(): void {
    this.form = this.fb.group({
      ftpServerType: [this.value?.ftpServerType || FtpServerType.SFTP, Validators.required],
      ftpServerLocation: [this.value?.ftpServerLocation || '', Validators.required],
      userName: [this.value?.userName || '', Validators.required],
      password: [this.value?.password || '', Validators.required],
      controlPort: [this.value?.controlPort || 22, Validators.required]
    });

    // Emit value on every change
    this.form.valueChanges.subscribe(val => {
      this.valueChange.emit(this.mapToModel(val));
    });
  }

  private mapToModel(formValue: any): FtpService {
    return {
      ftpServerType: formValue.ftpServerType as FtpServerType,
      ftpServerLocation: formValue.ftpServerLocation,
      userName: formValue.userName,
      password: formValue.password,
      controlPort: Number(formValue.controlPort)
    };
  }
  

  async testConnection() {
    const busyIndicator = this.showBusyDialog('Test Connection...');
    var result=await this.configService.testFTPConnection(this.form.value);
    busyIndicator.close();
    if(result.connectionstatus=='Success'){
      this.displayInfo("Connection succeeded",result.connectionstatus);
    }else{
      this.displayError(result.errormsg,result.connectionstatus);
    }
  }


  saveConfig() {
    console.log('Saving config:', this.form.value);
  }
}
